/* Pre-order state.
   A variant with 0 stock that can still be bought (continue selling) is a pre-order: the main and sticky
   Add to cart buttons read "Pre-order" and the dynamic checkout (Buy it now) is hidden. The state follows the
   selected variant, including after the theme's own script rewrites the button label on a variant change. */
(() => {
  if (window.__ntPreorder) return;
  window.__ntPreorder = true;

  const readCfg = (selector) => {
    const el = document.querySelector(selector);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  };
  const norm = (s) => String(s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const setText = (el, text) => { if (el && norm(el.textContent) !== norm(text)) el.textContent = text; };

  const apply = () => {
    const main = readCfg('script[data-nt-preorder]');
    const sticky = readCfg('script[data-nt-preorder-sticky]');
    const base = main || sticky;
    if (!base) return;
    const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!input) return;
    const ids = Object.assign({}, sticky && sticky.ids, main && main.ids);
    const pre = !!ids[input.value];

    if (main) {
      document.querySelectorAll('[id^="ProductSubmitButton"]').forEach((btn) => {
        const t = btn.querySelector('span');
        if (!t) return;
        if (btn.disabled || btn.getAttribute('disabled') !== null) { btn.removeAttribute('data-preorder'); return; }
        if (pre) { btn.setAttribute('data-preorder', 'true'); setText(t, main.label); }
        else {
          btn.removeAttribute('data-preorder');
          if (norm(t.textContent) === norm(main.label)) setText(t, main.add);
        }
      });
      document.querySelectorAll('[data-nt-buynow]').forEach((el) => {
        if (pre) el.style.setProperty('display', 'none', 'important');
        else el.style.removeProperty('display');
      });
    }

    if (sticky) {
      document.querySelectorAll('.pb-sticky__btn').forEach((btn) => {
        if (btn.disabled) return;
        const def = btn.dataset.label || sticky.add;
        if (pre) setText(btn, sticky.label);
        else if (norm(btn.textContent) === norm(sticky.label)) setText(btn, def);
      });
    }
  };

  let raf = null;
  const schedule = () => { if (raf) return; raf = requestAnimationFrame(() => { raf = null; apply(); }); };

  document.addEventListener('change', () => { setTimeout(apply, 50); setTimeout(apply, 600); }, true);
  document.addEventListener('click', () => { setTimeout(apply, 150); setTimeout(apply, 800); }, true);
  document.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('load', apply);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => { setTimeout(apply, 0); setTimeout(apply, 300); });
  }
  // Watch only the product forms and the sticky bar (not the whole page): their buttons are re-rendered on variant changes.
  const watch = () => {
    const mo = new MutationObserver(schedule);
    document.querySelectorAll('product-info, .nt-sticky').forEach((el) => mo.observe(el, { childList: true, subtree: true, characterData: true }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch, { once: true });
  else watch();
  apply();
})();
